import React, {useEffect} from 'react'
import { Link } from 'react-router-dom'
import imageProfilOn from '../../../images/profilon.png'
import imageProfilOff from '../../../images/profiloff.png'

const HeaderHomeUsers = ({ profil, keyUid, user, clients }) => { 

    useEffect(() => {

    },[user])

    return (
        <div className='pt-3 row border-bottom border-black pb-3 shadow'>

            {user?.uid ? 
                <>
                    {user.uid === keyUid && 
                        <div className='col text-end mt-1'>
                            {profil.map(p => (
                                <span key={p.id}>{p.nomEntreprise}</span>
                            ))}
                        </div>
                    }
                    {user.uid != keyUid && 
                        <div className='col text-end mt-1'>
                            {clients.filter(cl => cl.uid === user.uid).map(cl => (
                                <span key={cl.id}>{cl.surname} {cl.name}</span>
                            ))}
                        </div>
                    }
                    <div className='col-2 text-end'>
                        <Link to='/authUser' state={{ keyUid:keyUid }} style={{ color:'black' }}>
                            <img src={imageProfilOn} className='img-fluid' alt='image calendar' style={{ height:'2.2rem', width:'2.2rem' }} />
                        </Link> 
                    </div>
                </>
            : 
                <>
                    <div className='col text-end mt-1'>
                        <span>se connecter</span>
                    </div>
                    <div className='col-2 text-end'>
                        <Link to='/authUser' state={{ keyUid:keyUid }} style={{ color:'black' }}>
                            <img src={imageProfilOff} className='img-fluid' alt='image calendar' style={{ height:'2.2rem', width:'2.2rem' }} />
                        </Link> 
                    </div>
                </>
            }
        </div>
    )
}

export default HeaderHomeUsers

/*

        <div className='pt-3 row border-bottom border-black pb-3 shadow'>
            <div className='col text-end mt-1'>
                {user.uid ? 
                    user.uid === keyUid ? 
                        profil.map(p => (
                            <span key={p.id}>{p.nomEntreprise}</span>
                        ))
                    : 
                        clients.filter(cl => cl.uid === user.uid).map(cl => (
                            <span key={cl.id}>{cl.surname} {cl.name}</span>
                        ))
                : 
                    <span>se connecter</span>
                }
            </div>
            <div className='col-2 text-end'>
                <Link to='/authUser' state={{ keyUid:keyUid }} style={{ color:'black' }}>
                    {user.uid ? 
                        <img src={imageProfilOn} className='img-fluid' alt='image calendar' style={{ height:'2.2rem', width:'2.2rem' }} />
                    : 
                        <img src={imageProfilOff} className='img-fluid' alt='image calendar' style={{ height:'2.2rem', width:'2.2rem' }} />
                    }
                </Link>
            </div>
        </div>
        
*/
